/**
 * Full-page navigation wrapper. Exists so components can be unit-tested:
 * jsdom makes window.location and its methods non-configurable, so specs
 * mock this module instead of patching location.
 */
export function navigateTo(url: string) {
  window.location.assign(url);
}
